"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/BNFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_30)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_30`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6.59998 0H29.4V24H-6.59998V0Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6.59998 13.5958L29.4 22.5214V15.0358L-6.59998 6.81262V13.5958Z",
					fill: "black"
				}),
				/* @__PURE__ */ n("path", {
					d: "M29.4 16.4393V10.3572L-6.59998 1.43225V7.51436",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M14.9018 9.40418C15.1821 9.92173 15.3286 10.5012 15.3277 11.0898C15.3277 12.6021 14.3797 13.8926 13.0456 14.4014V10.2252C13.4456 10.1417 13.7474 9.77822 13.7474 9.34172C14.2316 9.34172 14.6246 8.93821 14.6246 8.43997H14.5951C15.0793 8.43997 15.5011 8.03646 15.5011 7.53822H13.0456V5.374L11.9937 3.42944L10.9411 5.374V7.53822H8.48564C8.48564 8.03646 8.9074 8.43997 9.39161 8.43997H9.36213C9.36213 8.93821 9.75512 9.34172 10.2393 9.34172C10.2393 9.77822 10.5404 10.1417 10.9404 10.2252V14.5319C9.3902 14.1537 8.24003 12.7565 8.24003 11.0898C8.24003 10.4793 8.39441 9.90523 8.66599 9.40418C7.89687 10.1908 7.42249 11.2659 7.42249 12.4526C7.42249 14.861 9.37477 16.814 11.7839 16.814C14.193 16.814 16.1453 14.861 16.1453 12.4526C16.1453 11.2659 15.6702 10.1901 14.9018 9.40418Z",
					fill: "#D80027",
					stroke: "#231F20",
					strokeWidth: .210526,
					strokeMiterlimit: 10
				}),
				/* @__PURE__ */ n("path", {
					d: "M7.32703 15.9165C7.32703 15.9165 8.77895 17.861 11.9937 17.861C15.2084 17.861 16.6604 15.9165 16.6604 15.9165L17.6056 17.9074C17.6056 17.9074 16.1298 19.8519 11.9937 19.8519C7.85755 19.8519 6.38176 17.9074 6.38176 17.9074L7.32703 15.9165ZM2.46948 9.34595H3.93474L5.68422 11.2589V16.4133H3.84001V11.6154L2.46948 9.34595ZM21.4702 9.34595H20.0049L18.2554 11.2589V16.4133H20.099V11.6154L21.4702 9.34595Z",
					fill: "#D80027",
					stroke: "#231F20",
					strokeWidth: .210526,
					strokeMiterlimit: 10
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_30`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as BNFlag };
